var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.27 26.43a9.675 9.675 0 01-3.437-7.403V15c0-5.083-3.776-9.29-8.667-9.996v-1.56a1.444 1.444 0 10-2.889 0v1.56C13.385 5.71 9.611 9.917 9.611 15v4.027a9.685 9.685 0 01-3.45 7.414 2.523 2.523 0 00-.884 1.92 2.53 2.53 0 002.528 2.528H31.64a2.53 2.53 0 002.527-2.528c0-.74-.322-1.439-.897-1.931zM19.721 36.667a5.425 5.425 0 005.307-4.334H14.414a5.425 5.425 0 005.307 4.334z",
    fill: "#000"
  })));
}

export default SvgBell;